export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
  <path fill="currentcolor" fill-rule="evenodd" d="M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5Zm13.686 5.657L10.343 17l-5.03-5.03 1.657-1.656 3.373 3.372L17.03 7l1.656 1.657Z" clip-rule="evenodd"/>
</svg>`;
